import React, { Component } from 'react';
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CircularProgress } from 'material-ui/Progress';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import TextField from 'material-ui/TextField';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';
import moment from 'moment'

import { filter } from 'lodash'

import DataTable from './datatable'

import ContainerHeader from '../../../components/ContainerHeader/index';
import * as agendaitemdetails from '../../../actions/agendaitemdetails';
import * as loadswitchercommittees from '../../../actions/teamdetails';

class AgendaItemList extends Component {

    constructor(props) {
        super(props)
        this.state = {
            setValue: false,
            committee_id: Number(this.props.params.id ? this.props.params.id : this.props.loginUser.data.committee_id),
            smeetingId: Number(this.props.params.smeetingId ? this.props.params.smeetingId : 0),
            agendaitemList: null,
            agendaitemmeetingDetails: null,
        }
    }
    handleChangeTeam(e) {
        this.setState({ committee_id: Number(e.target.value) })
        this.setState({ setValue: false, agendaitemList: null, agendaitemmeetingDetails: null })
        this.props.actions.getAgendaItemDetailsList(e.target.value);
        this.props.loginUser.data.committee_id = e.target.value;
        this.props.actions.changePreferedTeamIdUser(this.props.loginUser.data)
    }

    handleChangeAgendaItem(e) {
        this.filterAgendaList(e.target.value)
    }

    filterAgendaList(smeetingId) {
        // console.log('smeetingId',smeetingId)
        if (smeetingId > 0) {
            this.setState({ smeetingId: Number(smeetingId) })
            let list = filter(this.props.getDataList.agendaitemdetailsList, ['smeetingId', smeetingId])
            // console.log(list)
            this.setState({ agendaitemmeetingDetails: list.length > 0 ? list[0] : null })
            list = list.length > 0 ? list[0].agendaList : []
            this.setState({ agendaitemList: list, })
        }

    }

    handleFilterText() {
        this.setState({ filterText: this.refs.filterTextInput.value ? this.refs.filterTextInput.value.toLowerCase() : undefined });
    };

    componentDidMount() {
        // console.log('props', this.props)
        this.props.actions.loadswitchercommittees();
        if (this.state.committee_id > 0)
            this.props.actions.getAgendaItemDetailsList(this.state.committee_id);
    }

    render() {
        const { getDataList, teamDetails, match } = this.props;
        const { agendaitemList, agendaitemmeetingDetails } = this.state;
        let dataList = <tr><td></td></tr>;
        let message = null;
        // console.log('agendaitemList', agendaitemList);
        if (getDataList && getDataList.Status) {
            message = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        if (agendaitemList) {
            // dataList = agendaitemList.map((_data, index) => {
            //     return (<TableCell key={index} data={_data} index={index} committee_id={this.state.committee_id} />);
            // })
        }
        if (getDataList && getDataList.agendaitemdetailsList && getDataList.agendaitemdetailsList.length > 0 && !this.state.setValue) {
            this.state.smeetingId = Number(this.props.params.smeetingId ? this.props.params.smeetingId : getDataList.agendaitemdetailsList[0].smeetingId)
            this.setState({ agendaitemList: getDataList.agendaitemdetailsList[0].agendaList })
            this.setState({ setValue: true })
            // console.log('smeetingId =>', this.state.smeetingId)
            this.filterAgendaList(this.state.smeetingId)
        }
        let _agendaitemList = null
        // console.log('smeetingId', this.state.smeetingId)
        if (getDataList && getDataList.agendaitemdetailsList && getDataList.agendaitemdetailsList.length > 0) {
            _agendaitemList = getDataList.agendaitemdetailsList.map(item => (
                <MenuItem key={item.smeetingId} value={item.smeetingId}
                    style={{ fontWeight: '500' }}>
                    {item.meetingName}
                </MenuItem>
            ))
        }

        let _TeamList = null
        // console.log('AddRole TeamList', roleList)
        const committeeList = teamDetails.switchteamdetailsList;
        if (committeeList && committeeList.length > 0) {
            _TeamList = committeeList.map(team => (
                <MenuItem key={team.id} value={team.id}
                    style={{ fontWeight: '500' }}>
                    {team.name}
                </MenuItem>
            ))
        }

        return (
            <div className="slideInUpTiny ">
                {message}
                <ContainerHeader title="Agenda Item List" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">

                        <Card className="mb-0">
                            <CardHeader className="bg-white p-0">
                                <div className="row p-2">
                                    <div className="col-3 pt-2 pl-4">
                                        <FormControl className="w-100 mb-2 col-12">
                                            <InputLabel htmlFor="age-simple">Team Switcher</InputLabel>
                                            <Select
                                                value={this.state.committee_id}
                                                onChange={this.handleChangeTeam.bind(this)}
                                                input={<Input id="age-simple" />}
                                            >
                                                {_TeamList}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="row p-2">
                                    <div className="col-3 pt-2 pl-4">
                                        <FormControl className="w-100 mb-2 col-12">
                                            <InputLabel htmlFor="age-simple">Meeting Switcher</InputLabel>
                                            <Select
                                                value={this.state.smeetingId}
                                                onChange={this.handleChangeAgendaItem.bind(this)}
                                                input={<Input id="age-simple" />}
                                            >
                                                {_agendaitemList}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-3 pl-4">
                                        <TextField margin="normal" className="mt-0 mb-4 col-md-12"
                                            name="description" label="Meeting Number"
                                            value={agendaitemmeetingDetails ? agendaitemmeetingDetails.meetingNumber : ''} />
                                    </div>
                                    <div className="col-3 pl-4">
                                        <TextField margin="normal" className="mt-0 mb-4 col-md-12"
                                            name="description" label="Status"
                                            value={agendaitemmeetingDetails ? agendaitemmeetingDetails.meeting_status : ''} />
                                    </div>
                                    <div className="col-3 pl-4">
                                        <TextField margin="normal" className="mt-0 mb-4 col-md-12"
                                            name="description" label="Date"
                                            value={agendaitemmeetingDetails ? moment(agendaitemmeetingDetails.m_Date).format('DD/MM/YYYY') : ''} />
                                    </div>
                                </div>
                            </CardHeader>
                        </Card>
                        <div className="mt-2 row">
                            <div className="col-12">
                            <br/>
                                <Card className="mb-0">
                                    <CardHeader className="bg-white p-0">
                                        <div className={`search-bar right-side-icon bg-transparent `}>
                                            <div className="form-group">
                                                <input className="form-control border-1" type="search" placeholder="Search" onChange={this.handleFilterText.bind(this)}
                                                    ref="filterTextInput" value={this.state.filterText} />
                                                <button className="search-icon"><i className="zmdi zmdi-search zmdi-hc-lg" /></button>
                                            </div>
                                        </div>
                                    </CardHeader>
                                </Card>
                                <br/>
                                <DataTable className="mt-4" data={agendaitemList && agendaitemList.length > 0 ? agendaitemList : null}
                                    filterText={this.state.filterText} />
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

function mapStateToProps(state, ownProps) {
    // console.log('state=>', state)
    const { loginUser, agendaitemDetails, teamDetails } = state
    const { match } = ownProps
    return { loginUser, getDataList: agendaitemDetails, teamDetails, params: ownProps.match.params, match }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, agendaitemdetails, loadswitchercommittees), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(AgendaItemList);



// WEBPACK FOOTER //
// ./app/agendaitemdetails/agendaitemlist/index.js